import ServicePageLayout from "@/components/ServicePageLayout";
import WorkGallery from "@/components/WorkGallery";
import { IMAGES } from "@/data/site";

export default function LandscapingConsultancy() {
    return (
        <ServicePageLayout
            seoTitle="Landscaping Consultancy | The Sens Civil Works Consultancy — Gorakhpur"
            seoDescription="Practical landscape and garden consultancy in Gorakhpur — garden planning, plant selection, hardscape, irrigation and maintenance guidance."
            overline="Landscape & Garden Consultancy"
            title="Gardens Planned with the Same Rigour as Buildings"
            heroDescription="Practical guidance for garden planning, plant selection, hardscape, irrigation and maintenance."
            image={IMAGES.landscaping.url}
            imageAlt={IMAGES.landscaping.alt}
            intro={[
                "A good garden is engineered as much as it is planted — levels, drainage, soil preparation, hardscape and irrigation all decide whether a landscape thrives or struggles.",
                "With decades of site experience, the consultancy approaches landscaping practically: what will grow well in Gorakhpur's climate, how water will move across your plot, and what maintenance the design will actually demand.",
            ]}
            coveredTitle="What the Consultancy Covers"
            covered={[
                "Garden layout planning for homes, institutions and societies",
                "Plant selection suited to local climate and maintenance capacity",
                "Hardscape guidance — paving, edging, retaining and seating",
                "Irrigation planning and water management",
                "Review of landscaping quotations and work quality",
                "Ongoing maintenance guidance for lasting results",
            ]}
            closing="The emphasis is always on gardens that remain beautiful with realistic upkeep — not designs that look good only in the first season."
            ctaLabel="Plan Your Garden"
            ctaLink="/contact?service=Landscaping"
            gallery={<WorkGallery />}
        />
    );
}
